import React, {useEffect,useState} from 'react';
import {FormValidator, useFormValidator, Inputs,} from 'coaz-ui';
import client from '../client'

const AddTariff = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [tariffable,setTariffable] = useState(null);
    const [criteriaValue,setCriteriaValue] = useState(null);
    const [criteriaValues,setCriteriaValues] = useState([]);
    const [price,setPrice] = useState(0);
    const [durationUnit,setDurationUnit] = useState(null);
    const [durationUnits,setDurationUnits] = useState([]);
    const [duration,setDuration] = useState(0);
    const [isDefault,setDefault] = useState(false);
    const minWidth = 240;
    const {request, errorMessage,getByReference} = client;

    const submit = async (e) => {
        if(!tariffable || !criteriaValue) return;
        try {
            const response = await request('POST','tariffs',{
                tariffableReference:params.tariffableReference,
                criteriaValue:criteriaValue.ref && criteriaValue.ref.value?criteriaValue.ref.value:criteriaValue,
                price:price,
                durationUnit:durationUnit,
                duration:duration,
                default:isDefault
            });

            if (response && response.tariffableReference) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:'tariffable',
            type:'text', 
            name:'tariffable',
            disabled:true,
            value:tariffable && tariffable.name?tariffable.name:'',   
            placeholder:'Enter name...'
        },
        {
            label:'Criteria Value',
            type:'select',
            options:() => {
                let options = [];
                criteriaValues && criteriaValues.map((option,i) => options.push(<option key={i} value={option.ref && option.ref.value?option.ref.value:option}>{option.name?option.name:option}</option>));
                return options;
            },
            name:'criteriaValue', 
            value:criteriaValue && criteriaValue.ref && criteriaValue.ref.value?criteriaValue.ref.value:criteriaValue?criteriaValue:'',
            onChange:(e) => handleChange(e,(e) => {
                if(e.target.value === '') {
                    setCriteriaValue(null);
                } else {
                    let value = criteriaValues.find((crit) => {return crit.ref && crit.ref.value == e.target.value || crit == e.target.value});
                    setCriteriaValue(value);
                }
            })
        },
        {
            label:'Price',
            type:'number', 
            name:'price',
            value:price,   
            placeholder:'Enter price...',
            onChange:(e) => {handleChange(e,(e) => {
                let value = e.target.value;
                if(isNaN(value)) {
                    return;
                }
                setPrice(value);
            })},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Duration Unit',
            type:'select',
            options:() => {
                let options = [];
                durationUnits.map((option,i) => options.push(<option key={i}>{option.unit}</option>));
                return options;
            },
            name:'durationUnit', 
            value:durationUnit?durationUnit.unit:'',
            onChange:(e) => handleChange(e,(e) => {
                let value = durationUnits.find(unit => {return unit.unit == e.target.value}); 
                setDurationUnit(value);
            })
        },
        {
            label:'Duration',
            type:'number', 
            name:'duration',
            value:duration,   
            placeholder:'Enter duration...',
            onChange:(e) => {handleChange(e,(e) => {
                let value = e.target.value;
                if(isNaN(value)) {
                    return;
                }
                setDuration(value);
            })},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Default',
            type:'checkbox',
            name:'default',
            value:isDefault,   
            onChange:(e) => {
                setDefault(!isDefault);
            }
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        if(!params || !params.tariffableReference) return;
        (async () => { 
            let taffble = null;

            await request("GET","resolve",null,{ref:params.tariffableReference})
            .then((response) => {
                if(response && response.ref) {
                    taffble = response
                } 
            })
            .catch((error) => {
                console.log(error);
            })
            
            setTariffable(taffble);
            
            if(taffble && taffble.criteriaPathItemId) {
                let tariffs = []
                await request('GET','tariffs/by-tariffable',null,{tariffableReference:taffble.ref.value})
                .then((response) => { 
                    if(response && response.length > 0) {
                        tariffs = response;
                    } 
                })
                .catch((error) => {
                    console.log(error)
                })
                let criteriaPathItem = null;
                await request('GET',`criteriapathitems/${taffble.criteriaPathItemId}`)
                .then((response) => {
                    if(response) {
                        criteriaPathItem = response;
                    } 
                })
                .catch((error) => {
                    console.log(error)
                })

                if(!criteriaPathItem) {
                    return;
                }
                
                await request('GET','resolve-all',null,{ref:criteriaPathItem.ref})
                .then((response) => {
                    if(response && response.length > 0) {
                        let avai = [];
                        if(tariffs.length > 0) {
                            for(let crit of response) {
                                let found = tariffs.find((tariff) => {return tariff.criteriaValue == crit || (crit.ref && crit.ref.value && tariff.criteriaValue == crit.ref.value)});
                                if(!found) {
                                    avai.push(crit);
                                }
                            }
                            setCriteriaValues(avai);
                            setCriteriaValue(avai[0]);
                        } else {
                            setCriteriaValues(response);
                            setCriteriaValue(response[0]);
                        }
                    } else {
                        setCriteriaValues([]);
                    }
                })
                .catch((error) => {
                    setCriteriaValues([]);
                })
                await request('GET',`durationunits`)
                .then((response) => {
                    if(response && response.length > 0) {
                        setDurationUnit(response[0]);
                        setDurationUnits(response);
                    } else {
                        setDurationUnits([]);
                    }
                })
                .catch((error) => {
                    setDurationUnits([]);
                })
            }
            setLoading(false);
        })()
    },[])

    return (
        <FormValidator>
            <div className='w-full h-auto shrink-0'>
                <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
            </div>
        </FormValidator>
      )
}

export default AddTariff